module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan3-1-6bd26153ab0bbebe0905bdf6ed34e876.webp";